import React from 'react';
import Footer from '../nav/footer';
import useMedia from 'use-media';
import NewsLetterRegister from '../components/newsLetterRegister';
import { useState, useEffect } from 'react';
import { textInResolution } from '../multiFunctions';
import { storyText1, storyText2, belowLogoText, sphareText } from './text';
import { faTextHeight, faMugHot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    tab1firstText,
    tab1SecontText,
    tab1thirdText,
    tab1ForthText,
} from './text';

function getWindowDimensions() {
    // Ensure 'window' is defined to avoid issues during server-side rendering (SSR)
    const hasWindow = typeof window !== 'undefined';
    let screenSize = {
        width: hasWindow && window.screen.width,
        height: hasWindow && window.screen.height
    }
    return screenSize;
}

function NewsLetter() {
    let screenSize = {
        width: window.screen.width,
        height: window.screen.height
    }
    const [windowDimensions, setWindowDimensions] = useState(screenSize);
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');
    const isTablet =
    screenSize.width >= 768 && screenSize.width < 1024 ? true : false;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleResize = () => {
                setWindowDimensions(getWindowDimensions());
            };

            window.addEventListener('resize', handleResize);

            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);
    
    let mainStyle = {
        backgroundSize: "100% 100%",
        display: "flex",
        flexFlow: "column"
    }
    let titleStyles = {
        fontSize: textInResolution("xx-large", "large", "x-large", "xx-large", windowDimensions),
    }
    let storyStyle = {
        fontSize: textInResolution("large", "medium", "large", "x-large", windowDimensions),
    }
    let imageURL = textInResolution("./img/newsLetter768.jpg", "./img/newsLetter1024.jpg", "./img/newsLetter1440.jpg", "./img/newsLetter1440.jpg", windowDimensions);
    let styleStoryArea = {
        height: "25%", display: "flex", flexFlow: "row", maxWidth: "{screen.width}px"
    }
    let logoCafeStyle = {
        position: "absolute", 
        top: textInResolution("3%", "3%", "3%", "3%", windowDimensions), 
        left: textInResolution("3%", "3%", "3%", "3%", windowDimensions),
        display: "flex", 
        flexFlow: "column", 
        textAlign: "center"
    }
    
    let spheareStyle = {
        width: textInResolution("100px", "100px", "150px", "250px", windowDimensions),
        height: textInResolution("100px", "100px", "150px", "250px", windowDimensions),
        borderRadius: "50%",
        backgroundColor: "black",
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        marginTop: "10px",
        position: "absolute", 
        top: textInResolution("3%", "3%", "3%", "3%", windowDimensions),
        left: textInResolution("50%", "53%", "50%", "50%", windowDimensions),
    }
    let spheareMovileStyle = {
        width: "100px",
        height: "100px",
        borderRadius: "50%",
        backgroundColor: "black",
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        marginTop: "10px",
        position: "absolute", 
        top: "3%",
        right: "2%",
    }
    return (
        <>
            {isLargeScreen &&
                <div style={{ backgroundColor:  "#F4DFBB" }}>
                    <div style={mainStyle}>
                        <div style={{ height: "75%", position: 'relative' }}>
                            <img src={imageURL} width="100%" alt=''/>
                            <div style={{ ...logoCafeStyle }}>
                                <a href='/'>
                                    <img src="/img/companyLogo.png" width="90px" height="90px" alt=''/>
                                </a>
                                <span style={{ ...storyStyle }} dangerouslySetInnerHTML={{ __html: belowLogoText }} />
                            </div>
                            <Tab1Content screenSize={screenSize} isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} />
                            <div style={{ ...spheareStyle }}>
                                <div style={{ ...storyStyle, textAlign: "center", color: "white", width: "100%" }}>{sphareText}</div>
                            </div>
                        </div>
                        <div style={{ ...styleStoryArea }}>
                            <div style={{ width: "15%", textAlign: "right" }}>
                                <img src='./img/ceoImage.png' alt='Newle'/>
                            </div>
                            
                            <div style={{ width: "30%" }}>
                                <div style={{ height: "15%" }}><span style={{ color: "red", ...titleStyles }} dangerouslySetInnerHTML={{ __html: "Our story<br/><br/>" }}></span></div>
                                <div style={{ height: "75%", textAlign: "justify", paddingLeft: "5px", paddingRight: "5px" }}><span dangerouslySetInnerHTML={{ __html: storyText1 }}></span></div>
                                
                            </div>
                            <div style={{ width: "30%" }}>
                                <div style={{ height: "15%" }}></div>
                                <div style={{ height: "75%", textAlign: "justify", paddingLeft: "5px", paddingRight: "5px" }}><span dangerouslySetInnerHTML={{ __html: storyText2 }}></span></div>
                                
                            </div>
                            {!isTablet &&
                                <>
                                    <div style={{ width: "30%", display: "flex", flexFlow: "row", textAlign: "center" }}>
                                        <div style={{ width: "50%", display: "flex", flexFlow: "column" }}>
                                            <FontAwesomeIcon icon={faTextHeight} style={{ fontSize: textInResolution("100px", "60px", "80px", "100px", screenSize) }}/>
                                            <span style={{ ...titleStyles, paddingTop: "10px"  }}>Made in Honduras</span>
                                            <span style={{ ...storyStyle, paddingTop: "10px", textAlign: "justify", paddingLeft: "5px", paddingRight: "5px"  }}>From high-altitud farms with ideal climate and rich soil</span>
                                        </div>                            
                                        <div style={{ width: "50%", display: "flex", flexFlow: "column", textAlign: "center" }}>
                                            <FontAwesomeIcon icon={faMugHot} style={{ fontSize: textInResolution("100px", "60px", "80px", "100px", screenSize) }}/>
                                            <span style={{ ...titleStyles, paddingTop: "10px"  }}>Made for real</span>
                                            <span style={{ ...storyStyle, paddingTop: "10px", textAlign: "justify", paddingLeft: "5px", paddingRight: "5px"  }}>Honest Coffee with meaningful story behind every cup</span>                          
                                        </div>
                                    </div>
                                </>
                            }
                            {isTablet &&
                            <>
                                <div style={{ width: "45%", display: "flex", flexFlow: "row", textAlign: "center" }}>
                                    <div style={{ display: "flex", flexFlow: "column", height: "100%" }}>
                                        <FontAwesomeIcon icon={faTextHeight} style={{ paddintTop: "10px", fontSize: textInResolution("100px", "60px", "80px", "100px", screenSize) }}/>
                                        <span style={{ ...titleStyles, paddingTop: "20px"  }}>Made in Honduras</span>
                                        <span style={{ ...storyStyle, paddingTop: "10px", textAlign: "justify", paddingLeft: "5px", paddingRight: "5px"  }}>From high-altitud farms with ideal climate and rich soil</span>
                                        <span style={{ ...storyStyle, paddingTop: "10px", textAlign: "justify", paddingLeft: "5px", paddingRight: "5px"  }}>Honest Coffee with meaningful story behind every cup</span>
                                    </div> 
                                </div>
                            </>
                            }
                        </div>
                    </div>
                </div>
            }
            {isSmallScreen &&
                <>
                <div id="mainDesktop" style={{ backgroundColor:  "#F4DFBB" }}>
                    <div style={{ padding: "5px"}}>
                        <Tab1Content screenSize={screenSize} isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
                    </div>
                    <div style={{ position: "relative", width: "100%"}}>
                        <img src="/img/newsLetterBMobile.jpg" style={{ width: '100%',
  height: 'auto',
  display: 'block' }} alt=''/>
                    <div style={{ ...spheareMovileStyle }}>
                        <div style={{ ...storyStyle, textAlign: "center", color: "white", width: "100%" }}>{sphareText}</div>
                    </div>
                    </div>
                </div>
                <Footer isSubscribeVisible={false}/>
                </>
            }
             
        </>
    );
}

export default NewsLetter;

function Tab1Content(props) {
    /* eslint-disable react/prop-types */
    let textStyles = {
        fontSize: textInResolution("small", "medium", "x-large", "xx-large", props.screenSize), 
        fontFamily: 'calibri',
        display: "inline-block", 
        width: "100%", 
        paddingBottom: "15px", 
        fontWeight: "600"
    }
    let floatingPopupDesktopStyle = {
        paddingLeft: "5px",
        paddingRight: "5px",
        position: "absolute", 
        top: textInResolution("3%", "3%", "3%", "3%", props.screenSize), 
        right: textInResolution("5%", "5%", "5%", "5%", props.screenSize),
        display: "flex", 
        flexFlow: "column", 
        textAlign: "center",
        width: "30%",
        backgroundColor: '#FFF2CD',
        border: "1px solid black",
        borderRadius: "20px",
        height: textInResolution("90%", "80%", "80%", "70%", props.screenSize),
    }
    let floatingPopupMovileStyle = {
        width: "100%",
        backgroundColor: '#FFF2CD',
        border: "1px solid black",
        borderRadius: "20px",
    }
    let flotingTextStyle = {
        paddingLeft: "10px",
        paddingRight: "10px"
    }
    return (
        <>
            {props.isLargeScreen &&
            <div style={{ ...floatingPopupDesktopStyle }}>
                <span style={{ textAlign: "center", paddingTop: '10px', ...textStyles }} dangerouslySetInnerHTML={{ __html: tab1firstText }}/>
                <span style={{ textAlign: "justify", ...textStyles }} dangerouslySetInnerHTML={{ __html: tab1SecontText }}/>
                <span style={{ textAlign: "justify",  ...textStyles }} dangerouslySetInnerHTML={{ __html: tab1thirdText }}/>
                <span style={{ textAlign: "justify", ...textStyles }} dangerouslySetInnerHTML={{ __html: tab1ForthText }}/>
                <NewsLetterRegister windowDimensions={props.screenSize} isDiscount={true} fontSize={textInResolution("medium", "medium", "large", "large", props.screenSize)} isSubscribeVisible={true}/>
            </div>
            }
            {props.isSmallScreen &&
                <div style={{ ...floatingPopupMovileStyle }}>
                    <div style={{ textAlign: "center", ...flotingTextStyle, paddingTop: "5px" }} dangerouslySetInnerHTML={{ __html: tab1firstText }}/><br/>
                    <div style={{  ...flotingTextStyle  }} dangerouslySetInnerHTML={{ __html: tab1SecontText }}/><br/>
                    <div style={{ textAlign: "justify", ...flotingTextStyle }} dangerouslySetInnerHTML={{ __html: tab1thirdText }}/>
                    <div style={{ textAlign: "justify", ...flotingTextStyle, paddingBottom: "10px" }} dangerouslySetInnerHTML={{ __html: tab1ForthText }}/>
                    <NewsLetterRegister windowDimensions={props.screenSize} isDiscount={true} fontSize={textInResolution("medium", "medium", "large", "large", props.screenSize)} isSubscribeVisible={true}/>
                </div>
            }
        </>
    )
}